// KPI Builder — charts beyond the recommended ones. Questions drawn by a backend handler keep their own chart: the handler decides how the bars are stacked, so the saved chart type would not change what the dashboard shows.
import { CHARTS } from 'constants/kpiBuilderCatalogue';
import { BuilderAnswers, ChartOption, RecipeId } from './types';

/** Questions whose chart is drawn by a dedicated handler or fixed layout, so no other chart fits. */
const FIXED_CHART: RecipeId[] = ['gap', 'funnel', 'questions', 'progress', 'ready', 'advanced', 'template'];

/** Plain charts the dashboard draws from any list of values. Map and funnels need their own data. */
const OTHER_IDS = ['metric', 'horizontalbar', 'bar', 'pie', 'donut', 'stackedbar', 'multibar', 'line', 'histogram', 'table'];

export const canPickAnyChart = (a: BuilderAnswers): boolean => !!a.recipe && !FIXED_CHART.includes(a.recipe);

export const isOtherChart = (id: string): boolean => OTHER_IDS.includes(id);

/** Every plain chart that is not already recommended for this question. */
export const otherCharts = (a: BuilderAnswers, suited: ChartOption[]): ChartOption[] =>
  canPickAnyChart(a) ? OTHER_IDS.filter((id) => !suited.some((s) => s.id === id)).map((id) => ({ ...CHARTS[id], desc: `Not made for this question. ${CHARTS[id].desc}` })) : [];
